/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import "components/elements/main/index.scss";
import {Box, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";
import {FlexBetween, FlexBox} from "components/flex-box";
import MockShopHeader from "components/elements/main/MockShopHeader";

import { Avatar, Card, Typography } from "@mui/material";
import { H2, H5, H6 } from "components/CustomTypography";
import {getLogo, getURI, openGoogleMapLocation, openInstagram, openWhatsApp} from "helpers/utils";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import * as ActionTypes from "constants/ActionTypes";
import CircularProgress from "@mui/material/CircularProgress";
import PlaceIcon from "@mui/icons-material/Place";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ButtonComponent from "components/Button";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShopHeaderNav from "../ShopHeaderNav";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { AppointmentBooking } from "components/appointments";

const ShopHeaderMini = (props) => {

    const {
        serviceError, reqStatus, isLoading, isLoadingBootInfo, bootupInfo, shopId,
        history, shopinfo, userMainAddStoreToFavlist, getShopProfile, includeNav, excludeBackOnHome,
        checkPendingPayments, pendingPayments
    } = props;

  const [state] = useState({
    layoutColumns: 3,
  });

    const [shopModeState, setShopModeState] = useState("PREVIEW");
    const [appointmentDialogOpen, setAppointmentDialogOpen] = useState(false);

    const handleBackHome = () => {
        history.push(`/shops`);
    };

    useEffect(() => {
        switch (reqStatus) {
            case ActionTypes.USER_MAIN_ADD_STORE_TO_FAVLIST_SUCCESS:
                getShopProfile(bootupInfo.appState.subdomain_shopId, false);
                break;
            default:
                break;
        }
    }, [serviceError, reqStatus]);

    // Check for pending payments when shop info is loaded
    useEffect(() => {
        if (shopinfo && shopinfo.subdomain && !pendingPayments.isLoading && pendingPayments.count === 0) {
            checkPendingPayments(shopinfo.subdomain, false);
        }
    }, [shopinfo, shopinfo?.subdomain]);


    const addShopFavourite = () => {
        userMainAddStoreToFavlist(shopinfo.id);
    };

    const handlePlayShopStory = () => {
        setShopModeState("STORIES");
    }

    const openGoogleMap = () => {
        openGoogleMapLocation(shopinfo.location);
    };

    const handleBookAppointment = () => {
        setAppointmentDialogOpen(true);
    };

    const handleAppointmentSuccess = (appointment) => {
        setAppointmentDialogOpen(false);
        // Navigate to user appointments page
        history.push(getURI(process.env.REACT_APP_TYPE, "appointment_success", "", "", ""));
    };

    const handleAppointmentError = (error) => {
        // Close the dialog when there's a booking error
        setAppointmentDialogOpen(false);
    };

    const handleViewOrders = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "orders", shopinfo.subdomain, "", ""));
    };

    const renderDefaultModule = () => (
        <>
        <Box
            mb={2}
            sx={{
                display: "flex",
                flexDirection: "row",
                p: "4px",
                height: "100%",
                width: "100%",
                alignItems: "center",
                bgcolor: "#f4f4f4"
            }}
        >
            {isLoadingBootInfo && <MockShopHeader height={100} />}
            {!isLoadingBootInfo &&
                <>
                    <Box width="25%" onClick={handlePlayShopStory} sx={{ position: 'relative' }}>
                        <Box sx={{ position: 'relative', width: 80, height: 80 }}>
                            <Avatar
                                src={getLogo(shopinfo.logo)}
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    mb: 2,
                                    border: '3px solid white',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                }}
                            />
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    bottom: 15,
                                    right: 8,
                                    backgroundColor: 'white',
                                    color: 'primary.main',
                                    width: 16,
                                    height: 16,
                                    zIndex: 1,
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                            >
                                <PlayCircleIcon fontSize="medium" />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box width="75%" >
                        <Box width="100%" alignItems="left">
                            <H2 textTransform="capitalize" fontSize="22px" fontWeight="bold" color="primary.black" ellipsis>
                                {shopinfo.title}
                            </H2>
                            <H6 fontSize="12px" color="grey.900">
                                {shopinfo.area && (shopinfo.area)}
                            </H6>
                        </Box>
                        <FlexBox width="100%" alignItems="left">
                            <FlexBox width="40%">
                                <IconButton onClick={() => openGoogleMap()}>
                                    <PlaceIcon fontSize={"medium"} color="primary" />
                                </IconButton>
                                {shopinfo.instahandle && <IconButton onClick={() => openInstagram(shopinfo.instahandle)}>
                                    <InstagramIcon fontSize={"medium"} color="primary"/>
                                </IconButton>
                                }
                                {shopinfo.whatsapphandle &&
                                    <IconButton onClick={() => openWhatsApp(shopinfo.whatsapphandle)}>
                                        <WhatsAppIcon fontSize={"medium"} color="primary"/>
                                    </IconButton>
                                }
                            </FlexBox>
                            <Box width="60%" alignItems="left">
                                <FlexBox gap={1} flexDirection="column">
                                    {/* Pending Payment Orders Button */}
                                    {pendingPayments.has_pending_payments && <ButtonComponent
                                        sx={{
                                            mt: 1,
                                            mb: 1,
                                        }}
                                        type="primary"
                                        variant="contained"
                                        name="Complete Payment"
                                        size="small"
                                        color="warning"
                                        startIcon={<ShoppingCartIcon />}
                                        onClick={handleViewOrders}
                                    />}
                                    
                                    {/* Appointment Booking Button */}
                                    {shopinfo.appointment_enabled && <ButtonComponent
                                        sx={{
                                            mt: 1,
                                            mb: 1,
                                        }}
                                        type="primary"
                                        variant="contained"
                                        name="Book Appointment"
                                        size="small"
                                        startIcon={<ScheduleIcon />}
                                        onClick={handleBookAppointment}
                                    />}
                                    
                                    {/* Follow Button */}
                                    {parseInt(shopinfo.fav) > 0 ?
                                        <ButtonComponent
                                            sx={{
                                                mt: 1,
                                                mb: 1,
                                            }}
                                            disabled
                                            variant="outlined"
                                            name="Following"
                                            size="small"
                                        />
                                        :
                                        isLoading ? <CircularProgress size="1rem"/> :
                                            <ButtonComponent
                                                sx={{
                                                    mt: 1,
                                                    mb: 1,
                                                }}
                                                type="secondary"
                                                variant="outlined"
                                                name="Follow us!"
                                                size="small"
                                                onClick={() => addShopFavourite()}
                                            />
                                    }
                                </FlexBox>
                            </Box>
                        </FlexBox>
                    </Box>
                </>
            }
        </Box>
        {includeNav && <ShopHeaderNav shopId={shopId} {...props} excludeBackOnHome={excludeBackOnHome} history={history} />}
        </>
    );

    const handleResetShopStory = () => {
        setShopModeState("PREVIEW");
    }

    const renderShopAsStories = (shopData) => (

        <div>
            <StoriesPlayer
                storiesData={shopData}
                setAsFav={addShopFavourite}
                onCancel={() => handleResetShopStory()}
            />
        </div>
    );

        const renderShopMode = (shopMode) => {
        switch (shopMode) {

            case "STORIES":
                const {id, shop_id, title, logo, video, topproducts, area} = shopinfo;
                let shopStoryData = [];
                let stories = [];

                if (video && video.length > 0) {
                    stories.push({
                        video: video[0].cdn.secure_url,
                        videoimage: logo && logo[0].cdn.secure_url
                    });
                } else {
                    topproducts && topproducts.map((product) => (
                        stories.push({
                            image: product.cdn.secure_url,
                        })
                    ));
                }

                if (stories.length < 1) {
                    stories.push({
                        image: logo && logo[0].cdn.secure_url,
                    });
                }

                shopStoryData.push(
                    {
                        user: {
                            avatar: logo[0].cdn.secure_url,
                            name: title,
                            area: area,
                        },
                        item: shopinfo,
                        favId: shop_id,
                        stories: stories,
                    }
                );

                return renderShopAsStories(shopStoryData);

            case "PREVIEW":
            default:
                // causes render again on closing stories - reload of objects inside
                return renderDefaultModule();
        }
    }
    return (
        <Box>
            { renderShopMode(shopModeState)}
            
            {/* Appointment Booking Dialog */}
            <Dialog 
                open={appointmentDialogOpen} 
                onClose={() => setAppointmentDialogOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    Appointment for Video Shopping
                </DialogTitle>
                <DialogContent>
                    {shopinfo && (
                        <AppointmentBooking
                            storeId={shopinfo.id || shopinfo._id}
                            storeName={shopinfo.title}
                            onBookingSuccess={handleAppointmentSuccess}
                            onBookingError={handleAppointmentError}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAppointmentDialogOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

ShopHeaderMini.propTypes = {
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const shopHeaderMini = connect(
  ({ bootupInfo, userMainShops, userOrders }) => ({
    bootupInfo,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
      isLoadingBootInfo: bootupInfo.isLoading,
      shopinfo: bootupInfo.shopinfo,
      pendingPayments: userOrders.pendingPayments,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopHeaderMini);

export { shopHeaderMini as default };
